import React, { useContext, useState, useEffect } from "react"
import { AuthContext } from "../../context/AuthContext"
import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { useLocation, Link } from "react-router-dom";
import Loader from "../../components/Loader";
import NumberCard from "../../components/Card/NumberCard";
import { SubscriptionColumn } from "../../components/headerContent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Table from "../../components/Table";
import { faChevronLeft, faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import RowSubscription from "./RowSubscriptions";
import { useTranslation } from "react-i18next";

export default function Subscription() {
  const { apiUrl } = useContext(AuthContext);
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search);
  const subscriptionId = searchParams.get("subscriptionId");
  const referrer = searchParams.get("referrer");
  const [filteredData, setFilteredData] = useState([]);
  const { t } = useTranslation();

  const getDuration = (start, end) => {
    const startDate = new Date(start);
    const endDate = new Date(end);

    const months = (endDate.getFullYear() - startDate.getFullYear()) * 12 + (endDate.getMonth() - startDate.getMonth());
    return months;
  }

  const getSubs = async () => {
    const res = await axios.get(`${apiUrl}subscription/index`, { withCredentials: true });
    if (res.data && res.data !== 'No data') {
      return res.data.map(sub => ({
        ...sub,
        duration: getDuration(sub.startDate, sub.endDate)
      }));
    } else {
      return [res.data];
    }
  }

  const subscription = useQuery({
    queryKey: ["subscription"],
    queryFn: getSubs
  })

  useEffect(() => {
    if (subscription.data !== undefined && !subscription.data.includes("No data")) {
      if (subscriptionId) {
        const filteredData = subscription.data.filter(sub => sub.subscriptionId.toLowerCase() === subscriptionId);
        setFilteredData(filteredData);
      } else {
        setFilteredData(subscription.data);
      }
    }
  }, [subscription.data, subscriptionId]);

  if (subscription.data && subscription.data.includes("No data")) {
    return (
      <div className="ecp-container">
        <div className="ecp-container-content-error">
          <div className="error-container">
            <img src='../assets/ecp_error.svg' alt="icône d'erreur" />
            <div className="error-container-text">
              <h1 className="page-title">
                {t("Aucune subscription disponible")}
              </h1>
              <p className="page-link_home">
                <Link to="/"> {t("Revenir à l'accueil")}</Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (subscription.isLoading) {
    return <Loader />;
  }

  return (
    <div className="ecp-container">
      <div className="ecp-container-content">
        <div className="ecp-container-content-header">
          <div className="ecp-container-content-header-title">
            <div className="page-title page-logo">
              <img src="../assets/cisco_logo.png" alt="Logo de Cisco Webex" />
              <h1 className="page-title page-logo">Subscription</h1>
            </div>
          </div>
        </div>
        <section className="page-section">
          <NumberCard
            title="Nombre de subscriptions"
            number={
              filteredData.length
            }
            logo={faCircleCheck}
            color={"#AEC353"}
            stylesIcons={"logo-certificats"}
          />
        </section>
        {subscriptionId && (
          <div className="page-title page-link-timeline">
            <Link to={`/${referrer}`} className="buttons-ecp button-new"><FontAwesomeIcon icon={faChevronLeft} /> {t('Retour')}</Link>
          </div>
        )}
        <div className='cato-content-table'>
          <Table
            tableData={
              filteredData
            }
            tableColumns={SubscriptionColumn}
            rowComponent={RowSubscription}
            prefill={subscriptionId}
          />
        </div>
      </div>
    </div>
  );
}